module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "main-wrapper-cen"
  }, [_c('banner', {
    attrs: {
      "banner-data": _vm.homePageAdvertisementDTO.advList
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-warpper"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('bannerSquare', {
    attrs: {
      "newDailyGoodsList": _vm.newDailyGoodsList,
      "enterpriseShopGoodsList": _vm.enterpriseShopGoodsList,
      "selfRunGoodsList": _vm.selfRunGoodsList
    }
  }), _vm._v(" "), _c('perference-sale', {
    attrs: {
      "title": "为您推荐",
      "showTab": true,
      "isShowBg": true
    }
  })], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-323c75da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
// module id = 1566
// module chunks = 1